import React from "react";
import { Container, Title, Description, ContainerFooter } from "./styles";
import successIcon from "../../../../../assets/modal-icons/success-icon.svg";
import errorIcon from "../../../../../assets/modal-icons/error-icon.svg";
import AlertIcon from "../../../../../assets/modal-icons/alert-icon.svg";
import { Repeat } from "react-feather";
import Button from "../../../../../components/Button";

interface ContentProp {
  phoneString: string;
  onAlterPhone?: () => void;
  onConfirmPhone?: () => void;
  onOkClick?: () => void;
}

const ConfirmContent: React.FC<ContentProp> = ({
  phoneString,
  onAlterPhone,
  onConfirmPhone,
}) => {


  return (
    <Container>
      <img src={AlertIcon} alt="Alerta" />
      <Title>Seu número de celular está atualizado?</Title>
      <Description>
        Para prosseguirmos com o processo da biometria, enviaremos um link via
        SMS para o número
        <br />
        <b>{phoneString}</b>
      </Description>

      <ContainerFooter>
        <Button onClick={onAlterPhone} grey> <Repeat size={12}/>Alterar número</Button>

        <Button onClick={onConfirmPhone} primary>Confirmar</Button>
      </ContainerFooter>
    </Container>
  );
};

const SuccessContent: React.FC<ContentProp> = ({ phoneString, onOkClick }) => {
  return (
    <Container>
      <img src={successIcon} alt="Sucesso" />
      <Title>Tudo certo por aqui!</Title>
      <Description>Foi enviado um link via SMS para o número</Description>
      <Description>
        <b>{phoneString}</b>.
      </Description>
      <Description>
        Verifique a mensagem e siga as etapas seguintes.
      </Description>

      <ContainerFooter>
        <Button onClick={onOkClick} grey>Ok, entendi</Button>
      </ContainerFooter>
    </Container>
  );
};

const ErrorContent: React.FC<ContentProp> = ({ onOkClick }) => {
  return (
    <Container>
      <img src={errorIcon} alt="Erro" />
      <Title>Algo deu errado!</Title>
      <Description>
        Desculpe, não foi possível prosseguir com essa ação. Tente novamente em
        instantes.
      </Description>

      <ContainerFooter>
        <Button onClick={onOkClick} grey>Ok, entendi</Button>
      </ContainerFooter>
    </Container>
  );
};

export { SuccessContent, ConfirmContent, ErrorContent };
